import { makeFichaAvisoURL } from '@navent-jobs/interlinking'
import { getUrlParamByName } from '../../../hooks/get-url-param'

/**
 * Armamos la ruta correcta del aviso utilizando Interlinking, basandonos el ID del aviso
 * @param activeAviso {}
 * @returns 
 */

export const currentURL = (activeAviso) => {
  return activeAviso && activeAviso.aviso
    ? makeFichaAvisoURL({
        id: activeAviso.aviso.id,
        titulo: activeAviso.aviso.titulo,
        empresa: activeAviso.aviso.empresa,
      })
    : ''
}

// Se chequea si el usuario ingresa a la ficha desde un mail BTS (bts-avisos-labs)
const comesFromBtsEmail = () => {
  const param = getUrlParamByName('utm_content')
  return param && param.includes('bts-avisos-labs')
}

/**
 * Obtenemos la ruta a donde tenemos que redirigir al usuario una vez ingresado a la ficha
 * Dependiendo si ingresa desde un BTS o no
 * @param activeAviso
 * @returns 
 */

export const getRedirectlUrl = (activeAviso) => {
  let currentUrlWithHash = currentURL(activeAviso).concat(window.location.hash)

  if (comesFromBtsEmail()) {
    const params = `?${window.location.href.split('?')[1]}&utm_term=nueva`
    currentUrlWithHash = currentUrlWithHash.concat(params)
  }

  return currentUrlWithHash
}

/**
 * Se chequea si el usuario ingreso una url incorrecta de una ficha inexsistente y lo reubicamos en una correcta
 * @param activeAviso 
 * @param match 
 * @returns 
 */

export const wrongUrl = ({ activeAviso, match }) => {
  const url = currentURL(activeAviso)
  return url !== '' && match.url && match.url !== url
}